<template>

  <edit-pane
    :prefix="(formData.type ? formData.type + ': ' : 'Workflow: ')"
    :title="(formData.name ? formData.name : 'Details')"
    :show-title="!isSite"
    :layout="isSite ? 'right' : 'top'"
    :is-edit="editing"
    :show-edit-button="isAdd ? false : true"
    @edit="log"
    @cancel="log"
    @save="onSave">

       <el-form :label-position="disabled ? 'left' : 'top'" :label-width="disabled ? '' : '130px'">

        <el-row :gutter="10" align="start">

        <el-col v-if="formData.type || editing" :sm="24" :md="24" :lg="6">
           <select-input v-if="editing" label="Type" v-model="formData.type" required :list="workflowOption" filterable create :disabled="!editing" />
        </el-col>

        <el-col v-if="isSite && (formData.category || editing)" :sm="24" :md="24" :lg="6">
          <select-input label='Category' v-model='formData.category' :list="wfCategoryOption" filterable create  :disabled="!editing" />
        </el-col>

        <el-col v-if="formData.name || editing" :sm="24" :md="24" :lg="18">
          <text-input label="Name" v-model="formData.name" required :disabled="!editing" />
        </el-col>

          <template v-if="!isSite">

            <el-col v-if="formData.setupTime || editing" :sm="24" :md="12" :lg="6">
              <integer-input
                label="Setup Time"
                v-model="formData.setupTime"
                :suffix="disabled ? formData.setupTimeUnits : ''"
                prefix="fa fa-clock text-muted"
                :is-prefix-icon="true"
                :disabled="!editing" />
            </el-col>

            <el-col v-if="editing" :xs="12" :sm="12" :md="10" :lg="6">
              <select-input
                label="Setup Units"
                v-model="formData.setupTimeUnits"
                :list="unitsOption"
                :disabled="!editing" />
            </el-col>

            <el-col v-if="formData.taskTime || editing" :sm="24" :md="12" :lg="6">
              <integer-input
                label="Task Time"
                v-model="formData.taskTime"
                :suffix="disabled ? formData.taskUnits : ''"
                prefix="fa fa-clock text-muted"
                :is-prefix-icon="true"
                :disabled="!editing" />
            </el-col>

            <el-col v-if="editing" :xs="12" :sm="12" :md="10" :lg="6">
              <select-input
                label="Task Units"
                v-model="formData.taskUnits"
                :list="unitsOption"
                :disabled="!editing" />
            </el-col>

            <el-col v-if="formData.gradingMax || editing" :sm="24" :md="12" :lg="6">
              <integer-input
                label="Max. Grading (1..X)"
                v-model="formData.gradingMax"
                suffix="fa fa-star"
                :is-suffix-icon="true"
                :disabled="!editing" />
            </el-col>

          </template>

          <el-col v-if="!isSite && formData.workforceReq" :sm="24" :md="24" :lg="8">

            <integer-input
              label="Workforce (est.)"
              v-model="formData.workforceReq"
              prefix="fa fa-users text-muted"
              :is-prefix-icon="true"
              :disabled="isSite ? true : !editing" />

          </el-col>


          <el-col v-if="isSite && formData.workforceActual" :sm="24" :md="24" :lg="8">

            <integer-input
              label="Workforce (actual)"
              v-model="formData.workforceActual"
              prefix="fa fa-user text-muted"
              :is-prefix-icon="true"
              :suffix="'(est: ' + formData.workforceReq +')'"
              :disabled="!editing" />

          </el-col>


          <el-col v-if="formData.notesToWorkers || editing" :span="24">
              <html-input label="Notes to Workers" v-model="formData.notesToWorkers" :disabled="!editing" />
          </el-col>

          <el-col v-if="formData.remarks || editing" :span="24">
            <html-input label="Remarks" v-model="formData.remarks"  :disabled="!editing" />
          </el-col>

        </el-row>

      </el-form>

  </edit-pane>

</template>

<script>

import WorkflowMixins from '@/mixins/WorkflowMixins'

export default {
  mixins: [WorkflowMixins],

  props: {
    rowData: {
      type: Object,
      required: true
    },

    siteId: {
      type: [Number, String],
      default: null
    },

    isAdd: {
      type: Boolean,
      default: false
    }

  },


  methods: {

    log () {
      this.editing = !this.editing
    },

    onSave () {
      if (this.formData.name && this.formData.type) {

        this.saveForm(this, '/' + this.url, this.formData.id, this.formData,
          this.formData.name, this.log, this.log, true, this.isSite ? this.SITE_WORKFLOW_TABLE_REF : this.WORKFLOW_TABLE_REF)
      }
    }

  },


  data: function () {
    return {
      editing: this.isAdd ? true : false,
      isSite: this.siteId ? true : false,
      url: this.siteId ? 'workflow/sites' : 'workflow',
      modalTitle: 'Edit Workflow',
      workFlowTypeName: null,
      formData: {
        taskId: null,
        type: null,
        name: null,
        category: null,
        remarks: null,
        notesToWorkers: null,
        taskTime: null,
        taskUnits: null,
        workforceReq: null
      }
    }
  },

  mounted () {
    this.setEditState(this.isAdd)
    this.formData = this.rowData
  }

}
</script>

<style scoped>
.el-input-response-time {
  width: unset;
}
</style>



// WEBPACK FOOTER //
// EditWorkflow.vue?3980f813